<template>
  <div class="employer">
    <b-alert
      variant="danger"
      :show="!isCompanyVerified"
      class="company-alert mt-3 p-4"
      :class="[ shakeAlert ? 'shakeAlert' : '']"
    >
      <font-awesome-icon
        icon="exclamation-triangle"
        class="danger-icon m-auto"
      />
      <div v-if="$auth.user().company.status === 'pending'">
        <!-- eslint-disable -->
        <div
          v-html="$t('pages.dashboards.employer.verification.info', {
            companyTitle: $auth.user().company.title,
            appName: appName,
            companyPhone: $auth.user().company.phone
          })"
        />
        <!-- eslint-enable -->
        <div>
          {{ $t('pages.dashboards.employer.verification.wrong-phone') }}
          <router-link :to="{name: 'my-account', query: { company: true }}">
            {{ $t('pages.dashboards.employer.verification.update-profile') }}
          </router-link>
        </div>
      </div>
      <div v-if="$auth.user().company.status === 'rejected'">
        <!-- eslint-disable -->
        <div
          v-html="$t('pages.dashboards.employer.verification.rejected-info', {
            companyTitle: $auth.user().company.title,
            appName: appName
          })"
        />
        <!-- eslint-enable -->
      </div>
    </b-alert>
    <div class="body">
      <FreeOfferAlert />
      <div id="title">
        {{ $t('pages.dashboards.employer.publish.title') }}
      </div>
      <div class="d-flex justify-content-center pt-1 mb-2">
        <span
          class="mr-2"
          :class="isCorporate ? '' : 'font-weight-bold'"
        >
          {{ $t('pages.dashboards.employer.publish.switch.standart') }}
        </span>
        <b-switch
          v-model="isCorporate"
          theme="bootstrap"
          color="primary"
        />
        <span
          class="ml-2"
          :class="isCorporate ? 'font-weight-bold' : ''"
        >
          {{ $t('pages.dashboards.employer.publish.switch.corporate') }}
        </span>
      </div>
      <div class="">
        <div
          v-if="!isCorporate"
          class="row cards justify-content-center"
        >
          <OfferCard
            v-for="plan in standardPlans"
            :key="plan.key"
            :offer-name="plan.label"
            :old-price="plan.oldPrice"
            :new-price="plan.price"
            :inverted="plan.inverted"
            :header="plan.header"
            :footer="plan.footer"
            :more-info="plan.key"
            :publish="false"
            class="col-12 col-md-4"
            @shakeAlert="shakeIt()"
          />
        </div>
        <div
          v-else
          class="row cards justify-content-center"
        >
          <OfferCard
            v-for="plan in corporatePlans"
            :key="plan.key"
            :offer-name="plan.label"
            :old-price="plan.oldPrice"
            :new-price="plan.price"
            :inverted="plan.inverted"
            :header="plan.header"
            :footer="plan.footer"
            :more-info="plan.key"
            :publish="false"
            class="col-12 col-md-4"
            @shakeAlert="shakeIt()"
          />
        </div>
        <div
          id="title"
          class="mt-3"
        >
          {{ $t('pages.dashboards.employer.headhunter.title') }}
        </div>
        <OfferCardHr />
      </div>
    </div>
  </div>
</template>

<script>
import OfferCard from '@/components/jobs/blocks/OfferCard';
import OfferCardHr from '@/components/jobs/blocks/OfferCardHr';
import FreeOfferAlert from '@/components/jobs/employer/freeOfferAlert';

export default {
  components: {
    OfferCard,
    FreeOfferAlert,
    OfferCardHr
  },
  data() {
    return {
      shakeAlert: false,
      isCorporate: false,
    }
  },
  computed: {
    isCompanyVerified() {
      return this.$auth.user().company.isVerified;
    },
    appName() {
      return process.env.VUE_APP_NAME;
    },
    standardPlans() {
      return [
        {
          label: this.$t('pages.dashboards.employer.standard.basic.label', 'Basic offer'),
          oldPrice: 159,
          price: 100,
          inverted: false,
          key: 'basic',
          header: { color: '#17bfbf', title: this.$t('pages.dashboards.employer.standard.basic.header', 'Basic offer') },
          footer: [
            { title: this.$t('pages.dashboards.employer.standard.basic.footer.line-1', 'Feature line 1') },
            { title: this.$t('pages.dashboards.employer.standard.basic.footer.line-2', 'Feature line 2') },
          ]
        },
        {
          label: this.$t('pages.dashboards.employer.standard.standard.label', 'Standard offer'),
          oldPrice: 199,
          price: 139,
          inverted: true,
          key: 'standard',
          header: { color: '#658bc7', title: this.$t('pages.dashboards.employer.standard.standard.header', 'Standard offer') },
          footer: [
            { title: this.$t('pages.dashboards.employer.standard.standard.footer.line-1', 'Feature line 1') },
            { title: this.$t('pages.dashboards.employer.standard.standard.footer.line-2', 'Feature line 2') },
            { title: this.$t('pages.dashboards.employer.standard.standard.footer.line-3', 'Feature line 3') },
          ]
        },
        {
          label: this.$t('pages.dashboards.employer.standard.premium.label', 'Premium offer'),
          oldPrice: 249,
          price: 169,
          inverted: false,
          key: 'premium',
          header: { color: 'orange', title: this.$t('pages.dashboards.employer.standard.premium.header', 'Premium offer') },
          footer: [
            { title: this.$t('pages.dashboards.employer.standard.premium.footer.line-1', 'Feature line 1') },
            { title: this.$t('pages.dashboards.employer.standard.premium.footer.line-2', 'Feature line 2') },
            { title: this.$t('pages.dashboards.employer.standard.premium.footer.line-3', 'Feature line 3') },
            { title: this.$t('pages.dashboards.employer.standard.premium.footer.line-4', 'Feature line 4') },
          ]
        },
      ];
    },
    corporatePlans() {
      return [
        {
          label: this.$t('pages.dashboards.employer.corporate.standard.label', 'Standard pack'),
          oldPrice: 1000,
          price: 800,
          key: 'standard-pack',
          inverted: false,
          header: { color: '#17bfbf', title: this.$t('pages.dashboards.employer.corporate.standard.header', 'Standard pack') },
          footer: [
            { title: this.$t('pages.dashboards.employer.corporate.standard.footer.line-1', 'Feature line 1') },
            { title: this.$t('pages.dashboards.employer.corporate.standard.footer.line-2', 'Feature line 2') },
          ]
        },
        {
          label: this.$t('pages.dashboards.employer.corporate.company.label', 'Company pack'),
          oldPrice: 3200,
          price: 2780,
          key: 'company-pack',
          inverted: true,
          header: { color: '#658bc7', title: this.$t('pages.dashboards.employer.corporate.company.header', 'Company pack') },
          footer: [
            { title: this.$t('pages.dashboards.employer.corporate.company.footer.line-1', 'Feature line 1') },
            { title: this.$t('pages.dashboards.employer.corporate.company.footer.line-2', 'Feature line 2') },
            { title: this.$t('pages.dashboards.employer.corporate.company.footer.line-3', 'Feature line 3') },
          ]
        },
        {
          label: this.$t('pages.dashboards.employer.corporate.corporate.label', 'Corporate pack'),
          oldPrice: 15000,
          price: 13520,
          key: 'corporate-pack',
          inverted: false,
          header: { color: 'orange', title: this.$t('pages.dashboards.employer.corporate.corporate.header', 'Corporate pack') },
          footer: [
            { title: this.$t('pages.dashboards.employer.corporate.corporate.footer.line-1', 'Feature line 1') },
            { title: this.$t('pages.dashboards.employer.corporate.corporate.footer.line-2', 'Feature line 2') },
            { title: this.$t('pages.dashboards.employer.corporate.corporate.footer.line-3', 'Feature line 3') },
            { title: this.$t('pages.dashboards.employer.corporate.corporate.footer.line-4', 'Feature line 4') },
          ]
        },
      ];
    }
  },
  methods: {
    shakeIt() {
      this.shakeAlert = true;
      setTimeout(() => this.shakeAlert = false, 500);
    }
  }
}
</script>

<style lang="scss">
.company-alert {
  font-size: 0.95rem;
}

@media screen and (min-width: 768px) {
  .col-md-4 {
    max-width: 32%;
  }
}

.shakeAlert {
  animation: shake 0.82s cubic-bezier(.36,.07,.19,.97) both;
  transform: translate3d(0, 0, 0);
}

@keyframes shake {
  10%, 90% {
    transform: translate3d(-2px, 0, 0);
  }

  20%, 80% {
    transform: translate3d(4px, 0, 0);
  }

  30%, 50%, 70% {
    transform: translate3d(-8px, 0, 0);
  }

  40%, 60% {
    transform: translate3d(8px, 0, 0);
  }
}
</style>
